import { indexItems } from '@/mocks/comics';

const colorMap: Record<string, { bg: string; iconBg: string; text: string }> = {
  primary: { bg: 'hover:bg-primary-50 hover:border-primary-200', iconBg: 'bg-primary-100 text-primary-600', text: 'text-primary-600' },
  accent: { bg: 'hover:bg-accent-50 hover:border-accent-200', iconBg: 'bg-accent-100 text-accent-600', text: 'text-accent-600' },
  secondary: { bg: 'hover:bg-secondary-50 hover:border-secondary-200', iconBg: 'bg-secondary-100 text-secondary-600', text: 'text-secondary-600' },
};

export default function IndexSection() {
  return (
    <section id="index" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-10">
            <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">类型大全</h2>
            <p className="text-sm text-foreground-500">皮皮漫画类型大全，覆盖所有漫画类型</p>
          </div>
          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-3 gap-3 md:gap-4">
            {indexItems.map((item, i) => {
              const colors = colorMap[item.color] || colorMap.primary;
              return (
                <a
                  key={i}
                  href="#index"
                  className={`flex items-center gap-3 p-4 rounded-xl bg-background-100 border border-background-200/70 transition-colors cursor-pointer ${colors.bg}`}
                >
                  <div className={`w-10 h-10 rounded-xl flex items-center justify-center flex-shrink-0 ${colors.iconBg}`}>
                    <i className={`${item.icon} text-lg`}></i>
                  </div>
                  <div className="min-w-0">
                    <div className="text-sm font-semibold text-foreground-900 whitespace-nowrap">{item.title}</div>
                    <div className={`text-xs ${colors.text}`}>{item.count}</div>
                  </div>
                </a>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}